<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="RCEP专栏列表" name="1">
      <RcepAdd :updataID='updataID'></RcepAdd>
    </el-tab-pane>
    <el-tab-pane label="分类管理列表" name="2"></el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * RCEP专栏修改
 */
import RcepAdd from '../../../../static/form/RcepAdd.vue'
export default {
  components: {
    RcepAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/RcepColumngl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/RcepUpdate.vue